import { Control, Controller, UseFormGetValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/Employment/components/FormComponent/useStyles';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';

type PropsType = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  employmentTypeOptions: Enum[];
  index: number;
};

export const EmploymentTypeComponent = (props: PropsType) => {
  const { control, index, getValues, employmentTypeOptions } = props;

  const { t } = useTranslation();
  const requiredText = t('fieldIsRequired');

  const sxStyles = useSxStyles();

  const { filterActiveEnumsByFormSelections } =
    useFilterActiveEnumsByFormSelections({
      control,
      index,
      getValues,
    });

  const filteredOptions = filterActiveEnumsByFormSelections(
    employmentTypeOptions,
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employment.fEmplType`}
      rules={{
        required: requiredText,
      }}
      render={({ field: { onChange, value } }) => {
        return (
          <LegacyAutocompleteField
            options={filteredOptions}
            getOptionLabel={(o) => o.name}
            isOptionEqualToValue={(o, v) => o.code === v.code}
            onChange={(_event, value) => {
              onChange(value?.code || '');
            }}
            value={filteredOptions.find((o) => o.code === value)}
            disableClearable={true}
            label={t('laEmploymentType')}
            required={true}
            sx={sxStyles.selectStyle}
          />
        );
      }}
    />
  );
};
